import { h, Host, } from "@stencil/core";
import state from "../store";
import { exportParts } from "../../common/export-parts";
export class GxgModal {
    constructor() {
        this.flavor = "classic";
        this.padding = "s";
        this.footerJustifyContent = "flex-end";
        this.modalTitle = undefined;
        this.width = "100%";
        this.maxWidth = "300px";
        this.visible = false;
        this.zIndex = "100";
        this.silent = false;
        this.hideFooter = false;
        this.layerVisible = false;
        this.modalVisible = false;
        this.modalTransition = false;
    }
    parts = {
        closeButton: "close-button",
    };
    exportparts;
    el;
    /**
     * Emmited when the modal was closed
     */
    modalClosed;
    /**
     * Emmited when the modal was opened
     */
    modalOpened;
    componentWillLoad() {
        this.attachExportParts();
    }
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    componentDidLoad() {
        this.el.style.display = "block";
    }
    closeModal() {
        this.layerVisible = false;
        this.modalVisible = false;
        this.modalClosed.emit(true);
        setTimeout(function () {
            this.visible = false;
            this.modalTransition = false;
        }.bind(this), 250);
    }
    close() {
        // Implementation of the method
        this.closeModal();
    }
    watchVisibleHandler() {
        if (this.visible === true) {
            setTimeout(function () {
                this.modalTransition = true;
                setTimeout(function () {
                    this.layerVisible = true;
                    this.modalVisible = true;
                    this.modalOpened.emit(true);
                }.bind(this), 50);
            }.bind(this), 50);
        }
        else {
            this.closeModal.bind(this);
        }
    }
    modalHidden() {
        if (this.visible) {
            return "false";
        }
        else {
            return "true";
        }
    }
    render() {
        return this.visible === true ? (h(Host, { role: "dialog", "aria-hidden": this.modalHidden(), class: {
                "footer-justify-end": this.footerJustifyContent === "flex-end",
                "footer-justify-space-between": this.footerJustifyContent === "space-between",
                large: state.large,
                "flavor-alternate": this.flavor === "alternate",
            }, exportParts: this.exportparts ? this.exportparts : null }, h("div", { class: "modal-container" }, h("div", { class: {
                modal: true,
                "modal--visible": this.modalVisible,
                "modal--transition": this.modalTransition,
            }, style: {
                width: this.width,
                maxWidth: this.maxWidth,
                "z-index": this.zIndex + 1,
            } }, h("header", { class: "modal__header" }, h("span", { class: "modal__header__title" }, this.modalTitle), h("gxg-button", { icon: "gemini-tools/close", type: "tertiary", onClick: this.closeModal.bind(this), part: this.parts.closeButton })), h("div", { class: "modal__container" }, h("slot", null)), !this.hideFooter ? (h("footer", { class: "modal__footer" }, h("slot", { name: "footer" }))) : null)), h("div", { class: {
                layer: true,
                "layer--visible": this.layerVisible,
            }, style: { "z-index": this.zIndex } }))) : null;
    }
    static get is() { return "gxg-modal"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["modal.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["modal.css"]
        };
    }
    static get properties() {
        return {
            "flavor": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"classic\" | \"alternate\"",
                    "resolved": "\"alternate\" | \"classic\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "flavor",
                "reflect": false,
                "defaultValue": "\"classic\""
            },
            "padding": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "padding",
                    "resolved": "\"0\" | \"l\" | \"m\" | \"s\" | \"xl\" | \"xs\" | \"xxl\" | \"xxxl\"",
                    "references": {
                        "padding": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/modal/modal.tsx",
                            "id": "src/components/modal/modal.tsx::padding"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "padding",
                "reflect": true,
                "defaultValue": "\"s\""
            },
            "footerJustifyContent": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The footer justify content type"
                },
                "attribute": "footer-justify-content",
                "reflect": false,
                "defaultValue": "\"flex-end\""
            },
            "modalTitle": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The modal title"
                },
                "attribute": "modal-title",
                "reflect": false
            },
            "width": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The modal width"
                },
                "attribute": "width",
                "reflect": false,
                "defaultValue": "\"100%\""
            },
            "maxWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The modal max-width"
                },
                "attribute": "max-width",
                "reflect": false,
                "defaultValue": "\"300px\""
            },
            "visible": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Wether the modal is visible or not"
                },
                "attribute": "visible",
                "reflect": false,
                "defaultValue": "false"
            },
            "zIndex": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The z-index value of the modal"
                },
                "attribute": "z-index",
                "reflect": false,
                "defaultValue": "\"100\""
            },
            "silent": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute removes the sound that plays when the modal appears"
                },
                "attribute": "silent",
                "reflect": false,
                "defaultValue": "false"
            },
            "hideFooter": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute hides the footer."
                },
                "attribute": "hide-footer",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "layerVisible": {},
            "modalVisible": {},
            "modalTransition": {}
        };
    }
    static get events() {
        return [{
                "method": "modalClosed",
                "name": "modalClosed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emmited when the modal was closed"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "modalOpened",
                "name": "modalOpened",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emmited when the modal was opened"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "close": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {},
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "visible",
                "methodName": "watchVisibleHandler"
            }];
    }
}
//# sourceMappingURL=modal.js.map
